import { render, staticRenderFns } from "./InvoiceAdjustmentRuleOverview.vue?vue&type=template&id=2db01b3c&scoped=true&"
import script from "./InvoiceAdjustmentRuleOverview.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdjustmentRuleOverview.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAdjustmentRuleOverview.vue?vue&type=style&index=0&id=2db01b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db01b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db01b3c')) {
      api.createRecord('2db01b3c', component.options)
    } else {
      api.reload('2db01b3c', component.options)
    }
    module.hot.accept("./InvoiceAdjustmentRuleOverview.vue?vue&type=template&id=2db01b3c&scoped=true&", function () {
      api.rerender('2db01b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/InvoiceAdjustmentRule/InvoiceAdjustmentRuleOverview.vue"
export default component.exports